<div
  class="py-2"
  *tuiLet="boxAndPlaceQuantityPerFarm$ | async as quantity"
  #card="tuiActiveZone"
  (tuiActiveZoneChange)="onZoneChange($event)"
>
  <h2 class="font-semibold mb-4 text-[16px]">
    Адреса загрузки ({{ loadingAddressesForm.length }})
  </h2>
  <div class="flex items-center gap-x-2 rounded-xl mb-2 bg-neutral-100 py-3">
    <div class="w-2/12 pl-2">Питомник</div>
    <div class="w-2/12">Адрес</div>
    <div class="w-1/12">Коробки</div>
    <div class="w-1/12">Места</div>
    <div class="w-5/12">Комментарий</div>
    <div class="w-1/12"></div>
  </div>
  <div
    *tuiLet="cargoLoadingService.readonly$ | async as readonly"
    class="drag-n-drop-area"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    @for (address of loadingAddressesForm.controls; track $index) {
      <div
        [cdkDragDisabled]="readonly"
        cdkDrag
        class="flex gap-x-2 py-2 border-b items-center"
      >
        <div class="font-semibold w-2/12 pl-2">
          <span> {{ getLetterByIndex($index) | uppercase }}) </span>
          {{ address.controls.farmName.value }}
        </div>
        <div class="w-2/12">{{ address.controls.address.value }}</div>
        <div class="w-1/12">
          {{
            quantity?.[address.controls.farmName.value ?? '']?.boxQuantity ?? 0
              | number
              | spaceNumber
          }}
        </div>
        <div class="w-1/12">
          {{
            quantity?.[address.controls.farmName.value ?? '']
              ?.cargoPlaceQuantity ?? 0
              | number
              | spaceNumber
          }}
        </div>
        <div class="w-5/12">
          <tui-input
            [tuiTextfieldLabelOutside]="true"
            [formControl]="address.controls.comment"
            tuiTextfieldSize="m"
          ></tui-input>
        </div>
        <div class="w-1/12 flex gap-x-2 justify-end pr-2">
          <tui-badged-content>
            @if (address.controls.attachmentId.value) {
              <tui-badge-notification size="s" tuiSlot="top">
                1
              </tui-badge-notification>
            }
            <button
              (click)="
                $event.stopPropagation();
                openAttachmentsDialog$.next({
                  attachmentId: address.controls.attachmentId.value,
                  index: $index
                })
              "
              tuiIconButton
              size="s"
              icon="tuiIconPaperclip"
            ></button>
          </tui-badged-content>
          <button
            appearance="secondary"
            (click)="generateDriversReport$.next($index)"
            tuiIconButton
            size="s"
            icon="tuiIconImage"
          ></button>
        </div>
      </div>
    }
  </div>
</div>
